export default "__VITE_ASSET__BSq6soSD__"